import type { ReactElement } from 'react';
import HomeOutlined from '@mui/icons-material/HomeOutlined';
import TaskAltOutlined from '@mui/icons-material/TaskAltOutlined';
import LocalShippingOutlined from '@mui/icons-material/LocalShippingOutlined';
import DescriptionOutlined from '@mui/icons-material/DescriptionOutlined';
import ChatBubbleOutline from '@mui/icons-material/ChatBubbleOutlineOutlined';
import AlarmOutlined from '@mui/icons-material/AlarmOutlined';
import FolderOpenOutlined from '@mui/icons-material/FolderOpenOutlined';
import PeopleOutline from '@mui/icons-material/PeopleOutlined';
import PublicOutlined from '@mui/icons-material/PublicOutlined';
import DirectionsBoatOutlined from '@mui/icons-material/DirectionsBoatOutlined';
import PaidOutlined from '@mui/icons-material/PaidOutlined';
import HistoryOutlined from '@mui/icons-material/HistoryOutlined';
import NotificationsNoneOutlined from '@mui/icons-material/NotificationsNoneOutlined';
import SecurityOutlined from '@mui/icons-material/SecurityOutlined';
import TuneOutlined from '@mui/icons-material/TuneOutlined';

export type NavItem = { label: string; to: string; icon: ReactElement; badge?: 'approvals' };

/** The side menu: every page of the app, in groups. `to` is also the page's web address. */
export const NAV_GROUPS: { title?: string; items: NavItem[] }[] = [
  { items: [{ label: 'Home', to: '/', icon: <HomeOutlined /> }] },
  {
    title: 'Operations',
    items: [
      { label: 'Approvals', to: '/approvals', icon: <TaskAltOutlined />, badge: 'approvals' },
      { label: 'Shipments', to: '/shipments', icon: <LocalShippingOutlined /> },
      { label: 'Quotations', to: '/quotations', icon: <DescriptionOutlined /> },
      { label: 'Communications', to: '/communications', icon: <ChatBubbleOutline /> },
      { label: 'Reminders & Calendar', to: '/reminders', icon: <AlarmOutlined /> },
      { label: 'Documents', to: '/documents', icon: <FolderOpenOutlined /> },
    ],
  },
  {
    title: 'Business information',
    items: [
      { label: 'Customers', to: '/customers', icon: <PeopleOutline /> },
      { label: 'Overseas Agents', to: '/agents', icon: <PublicOutlined /> },
      { label: 'Carriers', to: '/carriers', icon: <DirectionsBoatOutlined /> },
    ],
  },
  {
    title: 'Management',
    items: [
      { label: 'Financial Overview', to: '/finance', icon: <PaidOutlined /> },
      { label: 'Activity History', to: '/history', icon: <HistoryOutlined /> },
    ],
  },
  {
    title: 'Settings',
    items: [
      { label: 'Notifications', to: '/notifications', icon: <NotificationsNoneOutlined /> },
      { label: 'Devices & Security', to: '/devices', icon: <SecurityOutlined /> },
      { label: 'Preferences', to: '/preferences', icon: <TuneOutlined /> },
    ],
  },
];
